import { useEffect, useState } from 'react';
import GenericCard from '../components/GenericCard';

import TableLeaderBoard from '../components/TableLeaderBoard';
import TopEquipos from '../components/TopEquipos';

import ApiService from '../services/ApiService';
import 'react-loading-skeleton/dist/skeleton.css';
import { useParams } from 'react-router-dom';
import '../index.css'; // <- Aquí se importa
export default function LeaderBoard() {
  const { id } = useParams();
  const defaultId = 5;
  const finalId = id || defaultId;

  useEffect(() => {
    // Aplica dark-mode al body
    document.body.classList.add('dark-mode');

    // Limpia la clase al salir de la página
    return () => {
      document.body.classList.remove('dark-mode');
    };
  }, []);

  // Loading general
  const [loading, setLoading] = useState(true);
  const [jugadoresRegistrados, setJugadoresRegistrados] = useState(null);
  const [jugadoresVivos, setJugadoresVivos] = useState(null);
  const [jugadores2Vidas, setJugadores2Vidas] = useState(null);
  const [jugadores1Vida, setJugadores1Vida] = useState(null);
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [leaderDataJornadas, setLeaderDataJornadas] = useState([]);
  const bannerImageUrl = process.env.REACT_APP_bannerImageUrl;
  const bannerLinkUrl = process.env.REACT_APP_bannerLinkUrl;
  const bannerTarget = process.env.REACT_APP_bannerTarget;

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      setLoading(true);
      try {
        const res = await ApiService.get(`/leaderboard/?survivorId=${finalId}`);


        if (res) {
          const safeSet = (data, setter, key) => {
            if (Array.isArray(data) && data.length > 0) {
              if (key) {
                setter(data[0][key]);
              } else {
                setter(data);
              }
            } else {
              console.error('datos vacios');
              setter('empty');
            }
          };

          safeSet(res.dataJugadoresRegistrados, setJugadoresRegistrados, 'total_jugadores');
          safeSet(res.dataJugadoresVivos, setJugadoresVivos, 'jugadores_vivos');
          safeSet(res.dataJugadores2Vidas, setJugadores2Vidas, 'jugadores_vivos2');
          safeSet(res.dataJugadores1Vida, setJugadores1Vida, 'jugadores_vivos1');
          safeSet(res.dataLeaderBoard, setLeaderBoardData);
          safeSet(res.dataJornadas, setLeaderDataJornadas);

        } else {
          console.warn('Respuesta vacía o malformada');
        }
      } catch (error) {
        console.error('Error al cargar leaderboard:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboardData();
  }, []);



  return (

    <div>

      {/*encabezados */}
      <div className="row">
        <GenericCard title="Registrados" value={jugadoresRegistrados} loading={loading} color="dark"
          icon="fa-user-plus" />
        <GenericCard title="Vivos" value={jugadoresVivos} loading={loading} color="dark"
          icon="fa-broadcast-tower" />
        <GenericCard title="2 Vidas" value={jugadores2Vidas} loading={loading} color="dark"
          icon="fa-users" />
        <GenericCard title="1 Vida" value={jugadores1Vida} loading={loading} color="dark"
          icon="fa-heartbeat" />
      </div>
      {/*fin encabezados */}

      <TopEquipos jornadas={leaderDataJornadas} survivorId={finalId} />

      <div className="row">
        {/* Columna de la tabla */}
        <div className="col-md-6 mb-4">
          <div className="card shadow h-100">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold textos">Clasificación</h6>
            </div>
            <div className="card-body scrollable-table">
              <TableLeaderBoard survivorId={finalId} />
            </div>
          </div>
        </div>

        {/* Columna con la imagen (banner) */}
        <div className="col-md-6 mb-4">
          <div className="card shadow h-100 d-flex align-items-center justify-content-center p-3">
            <a
              href={bannerLinkUrl}
              target={bannerTarget}
              rel="noopener noreferrer"
              style={{ width: '100%' }}
            >
              <img
                src={bannerImageUrl}
                alt="Banner"
                className="img-fluid rounded banner-img"
                style={{
                  maxHeight: '350px',
                  width: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                }}
              />
            </a>
          </div>
        </div>
      </div>

    </div>

  );
}
